import { effectScope, ref, watch } from 'vue';

const STORAGE_KEY = 'circuit-ds-dark';
const DARK_CLASS = 'my-app-dark';

const isDark = ref(false);

function applyClass(dark: boolean) {
  document.documentElement.classList.toggle(DARK_CLASS, dark);
}

// Detached scope so the watcher's lifetime is module-level, not bound to
// whichever component first called useDarkMode(). Without this, the watcher
// gets owned by the first caller's setup scope and is disposed on unmount
// (e.g., navigating away from /auctions), leaving subsequent toggles silent.
const scope = effectScope(true);
let initialized = false;

function ensureInit() {
  if (initialized) return;
  initialized = true;

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored !== null) {
    isDark.value = stored === '1';
  } else {
    isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  applyClass(isDark.value);

  scope.run(() => {
    watch(isDark, val => {
      applyClass(val);
      localStorage.setItem(STORAGE_KEY, val ? '1' : '0');
    });
  });
}

export function useDarkMode() {
  ensureInit();
  return { isDark };
}
